function buildSummary() {
  let summary = [];

  const initials = document.querySelector('[name="properties[Printed Initials]"]')?.value;
  const feeCents = window.mshPersoFeeCents || 0;

  if (initials) {
    summary.push(`Initials: ${initials.toUpperCase()}`);
  }

  if (feeCents > 0) {
    summary.push(`Cost: £${(feeCents / 100).toFixed(2)}`);
  }

  if (summary.length === 0) return '';

  return '— PERSONALISATION — | ' + summary.join(' | ');
}

window.MSH_PersoFeeHelpers = window.MSH_PersoFeeHelpers || {};

if (typeof window.MSH_PersoFeeHelpers.getFeeVariantIdForCents !== 'function') {
  window.MSH_PersoFeeHelpers.getFeeVariantIdForCents = function getFeeVariantIdForCents(handle, cents) {
    if (!handle || Number(cents) <= 0) return Promise.resolve(null);

    const feeVariantMapCache = window.__MSH_FEE_VARIANT_MAP_CACHE || (window.__MSH_FEE_VARIANT_MAP_CACHE = {});
    if (feeVariantMapCache[handle]) {
      return Promise.resolve(feeVariantMapCache[handle].get(Number(cents)) || null);
    }

    const feeProductCache = window.__MSH_FEE_PRODUCT_CACHE || (window.__MSH_FEE_PRODUCT_CACHE = {});
    const productPromise =
      feeProductCache[handle] ||
      fetch(`/products/${handle}.js`)
        .then((response) => {
          if (!response.ok) throw new Error(`Unable to fetch fee product for handle ${handle}`);
          return response.json();
        })
        .then((product) => {
          feeProductCache[handle] = Promise.resolve(product);
          return product;
        });

    feeProductCache[handle] = productPromise;

    return productPromise.then((product) => {
      if (!product || !Array.isArray(product.variants)) return null;

      const variantMap = new Map();
      product.variants.forEach((variant) => {
        variantMap.set(Number(variant.price), variant.id);
      });
      feeVariantMapCache[handle] = variantMap;
      return variantMap.get(Number(cents)) || null;
    });
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.mshFeeProductCache = {};
        this.mshFeeVariantMapCache = {};
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        if (!this._mshValidateRequiredProperties()) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const dsFeeCents = (this.dataset.mshPersoFeeCents || '0').toString().trim();
        const safeDsFeeCents = /^\d+$/.test(dsFeeCents) ? dsFeeCents : '0';
        const dsFeeHandle = this.dataset.mshPersoFeeHandle || 'personalisation-fee';
        const triggerValues = this._mshGetFeeTriggerValues();
        const feeRequired = triggerValues.length > 0;
        window.mshPersoFeeCents = Number(feeRequired ? safeDsFeeCents : '0');
        formData.set('properties[Personalisation Summary]', buildSummary());
        const nonce =
          window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);
        formData.set('properties[_MSH_PersoFeeCents]', feeRequired ? safeDsFeeCents : '0');
        formData.set('properties[_MSH_PersoFeeHandle]', String(dsFeeHandle));
        formData.set('properties[_MSH_PersoFeeFor]', triggerValues.join(', '));
        formData.set('properties[_MSH_PersoNonce]', nonce);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const mainQty = Number(formData.get('quantity') || 1);
        const mshPerso = this._mshReadPersonalisationSignals(formData);
        mshPerso.quantity = mainQty;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            return this._mshMaybeAddPersonalisationFee(mshPerso)
              .then((feeResponse) => feeResponse || response)
              .catch((error) => {
                console.warn('[MSH] Personalisation fee add failed', error);
                return response;
              });
          })
          .then((response) => {
            if (!response || !this.cart) return;

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mshPerso.variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      _mshReadPersonalisationSignals(formData) {
        const feeCents = Number(formData.get('properties[_MSH_PersoFeeCents]') || 0);
        const feeHandle = (formData.get('properties[_MSH_PersoFeeHandle]') || '').toString().trim();
        const triggerValues = this._mshGetFeeTriggerValues();
        const personalisationText = triggerValues.join(', ');
        const productHandle = (this.dataset.productHandle || this.getAttribute('data-product-handle') || '').trim();

        return {
          feeCents,
          feeHandle,
          personalisationText,
          variantId: formData.get('id'),
          productHandle,
          nonce: (formData.get('properties[_MSH_PersoNonce]') || '').toString().trim(),
        };
      }

      _mshMaybeAddPersonalisationFee(mshPerso) {
        if (!mshPerso.feeHandle || mshPerso.feeCents <= 0 || !mshPerso.personalisationText) {
          return Promise.resolve(null);
        }

        if (mshPerso.productHandle && mshPerso.productHandle === mshPerso.feeHandle) {
          return Promise.resolve(null);
        }

        return this._mshGetFeeVariantIdForCents(mshPerso.feeHandle, mshPerso.feeCents).then((variantId) => {
          if (!variantId) {
            console.warn(`[MSH] No personalisation fee variant for ${mshPerso.feeCents} cents`);
            return null;
          }

          const feeData = {
            items: [
              {
                id: variantId,
                quantity: mshPerso.quantity || 1,
                properties: {
                  _MSH_PersoFee: 'true',
                  _MSH_PersoFeeFor: mshPerso.personalisationText,
                  _MSH_PersoNonce: mshPerso.nonce,
                },
              },
            ],
          };

          if (this.cart) {
            feeData.sections = this.cart.getSectionsToRender().map((section) => section.id);
            feeData.sections_url = window.location.pathname;
          }

          return fetch(`${routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(feeData),
          })
            .then((feeResponse) => feeResponse.json())
            .then((feeResponse) => {
              if (feeResponse && feeResponse.status) {
                console.warn('[MSH] Personalisation fee add returned cart error', feeResponse);
                return null;
              }
              return feeResponse;
            });
        });
      }

      _mshGetFeeTriggerValues() {
        const form = this.form;
        if (!form) return [];

        const id = form.getAttribute('id') || '';
        const inside = Array.from(form.querySelectorAll('[data-msh-fee-trigger="1"]'));
        const outside = id
          ? Array.from(document.querySelectorAll(`[data-msh-fee-trigger="1"][form="${CSS.escape(id)}"]`))
          : [];
        const fields = Array.from(new Set([...inside, ...outside]));

        return fields
          .filter((el) => el && el.form === form)
          .map((el) => (el.value || '').toString().trim())
          .filter(Boolean);
      }

      _mshGetRelatedFormFields(selector) {
        const form = this.form;
        if (!form) return [];

        const id = form.getAttribute('id') || '';
        const inside = Array.from(form.querySelectorAll(selector));
        const outside = id
          ? Array.from(document.querySelectorAll(`${selector}[form="${CSS.escape(id)}"]`))
          : [];

        return Array.from(new Set([...inside, ...outside])).filter((el) => el && el.form === form);
      }

      _mshGetInlineErrorTarget(input) {
        if (!input) return null;

        const describedBy = (input.getAttribute('aria-describedby') || '').trim();
        if (describedBy) {
          const target = describedBy
            .split(/\s+/)
            .map((id) => document.getElementById(id))
            .find((el) => el && el.hasAttribute('data-msh-perso-error'));
          if (target) return target;
        }

        const wrap = input.closest('.msh-personalisation__meta, .field, .msh-personalisation');
        return wrap ? wrap.querySelector('[data-msh-perso-error]') : null;
      }

      _mshSetInlineFieldError(input, message) {
        if (!input) return;
        const err = this._mshGetInlineErrorTarget(input);
        if (err) {
          err.textContent = message;
          err.classList.add('is-visible');
        }
        input.classList.add('is-invalid');
        input.setAttribute('aria-invalid', 'true');
      }

      _mshClearInlineFieldError(input) {
        if (!input) return;
        const err = this._mshGetInlineErrorTarget(input);
        if (err && !err.dataset.mshStaticError) {
          err.textContent = '';
          err.classList.remove('is-visible');
        }
        input.classList.remove('is-invalid');
        input.removeAttribute('aria-invalid');
      }

      _mshValidateRequiredProperties() {
        const requiredFields = this._mshGetRelatedFormFields('[data-msh-required-property="true"]');
        let firstInvalid = null;

        requiredFields.forEach((field) => {
          if (!field.dataset.mshRequiredBound) {
            field.dataset.mshRequiredBound = '1';
            field.addEventListener('input', () => this._mshClearInlineFieldError(field));
            field.addEventListener('blur', () => {
              if ((field.value || '').toString().trim().length > 0) this._mshClearInlineFieldError(field);
            });
          }

          if ((field.value || '').toString().trim().length > 0) {
            this._mshClearInlineFieldError(field);
            return;
          }

          const message = field.dataset.mshRequiredMessage || 'Please complete this field.';
          this._mshSetInlineFieldError(field, message);
          if (!firstInvalid) firstInvalid = field;
        });

        if (!firstInvalid) return true;
        firstInvalid.focus();
        return false;
      }

      _mshFetchFeeProduct(handle) {
        if (!handle) return Promise.resolve(null);
        if (this.mshFeeProductCache[handle]) return Promise.resolve(this.mshFeeProductCache[handle]);

        return fetch(`/products/${handle}.js`)
          .then((response) => {
            if (!response.ok) throw new Error(`Unable to fetch fee product for handle ${handle}`);
            return response.json();
          })
          .then((product) => {
            this.mshFeeProductCache[handle] = product;
            return product;
          });
      }

      _mshGetFeeVariantIdForCents(handle, cents) {
        if (window.MSH_PersoFeeHelpers && typeof window.MSH_PersoFeeHelpers.getFeeVariantIdForCents === 'function') {
          return window.MSH_PersoFeeHelpers.getFeeVariantIdForCents(handle, cents);
        }

        if (!handle || cents <= 0) return Promise.resolve(null);
        return Promise.resolve(null);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
